import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import drawItActions from 'redux/actions/drawItActions'
import { localize } from 'helpers/translator'

const DrawItCancelConfirm = props => (
	<Confirm
		btOne={localize('global_no')}
		btTwo={localize('global_yes')}
		alertMessage={localize('draw_it_cancelConfirm')}
		actionButtonType={0}
		actionOne={() => {
			props.actions.cancelReject()
		}}
		actionTwo={() => props.actions.cancelConfirm()}
		closeAction={() => props.actions.cancelReject()}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		cancelReject: drawItActions.cancelReject,
		cancelConfirm: drawItActions.cancelConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(DrawItCancelConfirm)

export { DrawItCancelConfirm }
